/**
 * @selector body
 */
import BaseModule from '../../modules/BaseModule.js';
import fastdom from 'fastdom';

export default class MousePosition extends BaseModule {
    constructor() {
        super();
    }

    init() {
        this.el = document.documentElement;

        this.on('mousemove', this.onMouseMove);

        this.setupInitial();

        return this;
    }

    setupInitial() {
        this.el.style.setProperty('--mouse-x-percent', '0');

        this.el.style.setProperty('--mouse-y-percent', '0');
    }

    onMouseMove(e) {
        let windowWidth;
        let windowHeight;

        fastdom.measure(() => {
            windowWidth = window.innerWidth || document.documentElement.clientWidth;
            windowHeight = window.innerHeight || document.documentElement.clientHeight;
        });

        fastdom.mutate(() => {
            const { clientX, clientY } = e;

            this.el.style.setProperty('--mouse-x', `${clientX}px`);
            this.el.style.setProperty('--mouse-y', `${clientY}px`);

            this.el.style.setProperty('--mouse-x-percent', `${clientX / windowWidth}`);

            this.el.style.setProperty('--mouse-y-percent', `${clientY / windowHeight}`);
        });
    }
}
